import React from 'react';

var BestOfBadge = function BestOfBadge(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84.5 104",
    "aria-labelledby": "preheaderHoverText",
    role: "img",
    className: className
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#008354;}.cls-2{fill:#00623f;}.cls-3{fill:#fff;}")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Badge"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BG",
    className: "cls-1",
    d: "M82.1,0H2.4A2.41,2.41,0,0,0,0,2.41v99.88a1.72,1.72,0,0,0,2.37,1.58L42.25,88.64l39.88,15.23a1.72,1.72,0,0,0,2.37-1.58V2.41A2.41,2.41,0,0,0,82.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BG_accent",
    "data-name": "BG accent",
    className: "cls-2",
    d: "M0,71.18v31.11a1.72,1.72,0,0,0,2.37,1.58L42.25,88.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logomark",
    className: "cls-3",
    d: "M62.65,17.79H50.29a.94.94,0,0,0-.93.94V32h0L35.52,18.18a1.4,1.4,0,0,0-.39-.26l-.08,0a1.22,1.22,0,0,0-.46-.09H21.84a.94.94,0,0,0-.94.94V32h0V59.54a1,1,0,0,0,.94.94H34.19a.94.94,0,0,0,.94-.94V46.25L49,60.09a1.7,1.7,0,0,0,.39.27l.08,0a1.22,1.22,0,0,0,.46.09H62.65a.94.94,0,0,0,.94-.94V32h0V18.73A.94.94,0,0,0,62.65,17.79Z"
  }))));
};

export default BestOfBadge;